// extracted by mini-css-extract-plugin
module.exports = {"button":"icon-button_button__fXz0z","afterText":"icon-button_afterText__lWt_Z","beforeText":"icon-button_beforeText__PdgDn"};